<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Pu3Wji/tc-custom/9781913682446.jpg?1737687886918" alt="This image is the cover for the book Doll Collector"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Doll Collector
      </h1>
      <p class="bookDescription body article font2">
        <b>Her dolls are on display, but her crimes are hidden—until the façade begins to crack . . .</b><br/><br/> A couple and their young son burn to death in a house fire. A girl dies from a nut allergy. A woman falls under a train during rush hour. An accountant falls down the steps to his basement.<br/><br/> Their deaths appear to be accidents, but Gloria knows they were murdered. Because she murdered them. And every time Gloria kills, she buys a doll.<br/> But how many dolls will she need to keep her satisfied?<br/><br/> Gloria craves love and happiness and friendship, and will do anything to get what she craves. But now her behavior is spinning out of control, in this dark, compelling thriller.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joanna Stephen-Ward
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?91557330